var _style, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDashboardColored(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 81.1 90",
    style: {
      enableBackground: "new 0 0 81.1 90"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#234C72;}\n\t.st1{fill:#18405E;}\n\t.st2{fill:#237069;}\n\t.st3{fill:#1A5B53;}\n\t.st4{fill:#3BAD8C;}\n\t.st5{fill:#2C9172;}\n\t.st6{fill:#5CD3B4;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 45.8,
    className: "st0",
    width: 35.3,
    height: 76
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 16.9,
    className: "st1",
    width: 36.6,
    height: 62.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 30.2,
    y: 17.8,
    className: "st2",
    width: 36.6,
    height: 62.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 16.2,
    y: 34.7,
    className: "st3",
    width: 36.5,
    height: 48
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 15.4,
    y: 35.5,
    className: "st4",
    width: 36.5,
    height: 48
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 0.8,
    y: 52.5,
    className: "st5",
    width: 36.5,
    height: 36.7
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    y: 53.3,
    className: "st6",
    width: 36.5,
    height: 36.7
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardColored);
export default __webpack_public_path__ + "static/media/dashboardColored.4777db85e88232019d73d21406fac5c3.svg";
export { ForwardRef as ReactComponent };